import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'

type ListItemProps = {
  selected?: boolean
  bordered?: boolean
}

export const ListItem = styled.div<ListItemProps>`
  padding: ${Shapes.spacing[4]}px ${Shapes.spacing[6]}px;
  background: ${(props: ListItemProps) => (props.selected ? Colors.neutral50 : 'none')};
  border-bottom: ${({ bordered }) => (bordered ? `1px solid ${Colors.border}` : 0)};
  &:last-of-type {
    border-bottom: none;
  }
  cursor: pointer;

  &:hover,
  &.active {
    background: ${Colors.neutral50};
  }
`
